export const FEATURE_REQUEST_STATUSES = [
  'NEW',
  'ACCEPTED',
  'IN_PROGRESS',
  'DONE',
  'CLOSED',
] as const;

export type FeatureRequestStatus = (typeof FEATURE_REQUEST_STATUSES)[number];

export const FEATURE_REQUEST_TYPES = ['FEATURE', 'DEFECT'] as const;

export type FeatureRequestType = (typeof FEATURE_REQUEST_TYPES)[number];

export const FEATURE_REQUEST_PRIORITIES = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'] as const;

export type FeatureRequestPriority = (typeof FEATURE_REQUEST_PRIORITIES)[number];

export type FeatureRequestUserSummary = {
  userId: string;
  displayName: string;
};

export type FeatureRequestListItem = {
  _id: string;
  requestNumber: string;
  title: string;
  type: FeatureRequestType;
  priority: FeatureRequestPriority;
  status: FeatureRequestStatus;
  createdBy: string;
  createdByUser?: FeatureRequestUserSummary;
  assignedTo?: string;
  assignedToUser?: FeatureRequestUserSummary;
  createdAt: string;
  updatedAt: string;
};

export type FeatureRequestDetail = FeatureRequestListItem & {
  description: string;
  closedAt?: string;
};

export type FeatureRequestStats = {
  total: number;
  new: number;
  accepted: number;
  inProgress: number;
  done: number;
  closed: number;
};

export type FeatureRequestListResponse = {
  items: FeatureRequestListItem[];
  total: number;
  page: number;
  pageSize: number;
};

export type FeatureRequestComment = {
  _id: string;
  featureRequestId: string;
  comment: string;
  createdBy: string;
  createdByUser?: FeatureRequestUserSummary;
  createdAt: string;
  updatedAt: string;
};

export type FeatureRequestAttachment = {
  _id: string;
  featureRequestId: string;
  fileName: string;
  fileUrl: string;
  mimeType?: string;
  uploadedBy: string;
  uploadedByUser?: FeatureRequestUserSummary;
  uploadedAt: string;
};

export type FeatureRequestActivity = {
  _id: string;
  featureRequestId: string;
  action: string;
  oldValue?: string;
  newValue?: string;
  performedBy: string;
  performedByUser?: FeatureRequestUserSummary;
  createdAt: string;
  metadata?: Record<string, unknown>;
};

export type CreateFeatureRequestPayload = {
  title: string;
  type: FeatureRequestType;
  priority?: FeatureRequestPriority;
  description: string;
};

export type ListFeatureRequestsParams = {
  search?: string;
  status?: string;
  excludeStatuses?: string;
  type?: string;
  priority?: string;
  assignedTo?: string;
  createdBy?: string;
  createdFrom?: string;
  createdTo?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
};

export const FEATURE_REQUEST_STATUS_LABELS: Record<FeatureRequestStatus, string> = {
  NEW: 'New',
  ACCEPTED: 'Accepted',
  IN_PROGRESS: 'In Progress',
  DONE: 'Done',
  CLOSED: 'Closed',
};

export const FEATURE_REQUEST_TYPE_LABELS: Record<FeatureRequestType, string> = {
  FEATURE: 'Feature',
  DEFECT: 'Defect',
};

export const FEATURE_REQUEST_PRIORITY_LABELS: Record<FeatureRequestPriority, string> = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  CRITICAL: 'Critical',
};
